// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__2GjdW","content":"Modal_content__1VIbZ"};